import React from 'react';
import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import en from './locale/en';
import zh_CN from './locale/zh-cn';
import { Region } from './interface';
import { useLocale } from '../../utils/i18n';
import styles from './index.module.less';

const locales: Record<string, Record<string, Region[]>> = {
  en,
  'zh-cn': zh_CN,
};

export const useRegionData = () => {
  const [code] = useLocale();
  return locales[code];
};

const RegionSelect : React.FC<SelectProps<string>> = (props) => {
  const groups = useRegionData();
  const [search, setSearch] = React.useState('');
  const upperCaseSearch = search.toUpperCase();

  const children = Object.keys(groups).map(
    (key) => {
      const options = groups[key].filter(
        ({ B, C, N }) => (
          B.toUpperCase().indexOf(upperCaseSearch) >= 0
          || C.toUpperCase().indexOf(upperCaseSearch) >= 0
          || N.indexOf(upperCaseSearch) >= 0
        ),
      );

      if (options.length === 0) {
        return null;
      }

      return (
        <Select.OptGroup key={key} label={key}>
          {
              options.map(
                ({ B, C }) => (
                  <Select.Option key={B} value={B} title={C}>{C}</Select.Option>
                ),
              )
            }
        </Select.OptGroup>
      );
    },
  );

  return (
    <Select
      className={styles.select}
      showSearch
      searchValue={search}
      onSearch={setSearch}
      filterOption={false}
      {...props}
    >
      { children }
    </Select>
  );
};

export default RegionSelect;
